import React, { useContext, useEffect, useRef, useState } from "react";

import ReactECharts from "echarts-for-react";

import { AppSettings } from "../../config/app-settings";
import apiClient from "../../ApiClient";

export default function SiyasiKimlikDagilimi({ city, district }) {
  const context = useContext(AppSettings);

  const chartRef = useRef();

  const [chartOption, myChartOption] = useState(null);

  async function fetchData() {
    myChartOption(null);

    try {
      const response = await apiClient.customPost(
        `/query/preview`,
        {
          chart: 1,
          page_id: 23,
          title: "siyasi-kimlik",
          type: "siyasi-kimlik",
          description: "",
          customer: null,
          status: true,
          order: 1,
          connection_type: "local",
          sql: {
            column: [],
            condition: [
              city
                ? {
                    key: "IL",
                    value: context.removeTurkishCharacters(city).toUpperCase(),
                    operator: "=",
                    type: "and",
                  }
                : null,
              district
                ? {
                    key: "ILCE",
                    value: context
                      .removeTurkishCharacters(district)
                      .toUpperCase(),
                    operator: "=",
                    type: "and",
                  }
                : null,
            ].filter((item) => item !== null),
            group: [],
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response && response[0]?.data) {
        const data = JSON.parse(response[0]?.data);
        delete data.IL;
        delete data.ILCE;

        const keys = Object.keys(data);
        const values = Object.values(data);

        myChartOption({
          legend: {
            show: true,
            orient: "horizontal",
            left: "center",
            itemGap: 20,
            textStyle: {
              color: context?.theme === "light" ? "#000" : "#fff",
            },
          },
          calculable: true,
          yAxis: {
            type: "value",
            axisLabel: {
              textStyle: {
                color: context?.theme === "dark" ? "#fff" : "#000",
              },
            },
          },
          grid: { top: "5%", right: "2%", bottom: "15%", left: "5%" },
          tooltip: {
            trigger: "item",
            formatter: function (params) {
              return "%" + params.data;
            },
          },
          darkMode: window.location.host.includes("datakokpit") ? false : true,
          series: [
            {
              data: values,
              type: "bar",
              markPoint: {
                data: [
                  { type: "max", name: "Max" },
                  { type: "min", name: "Min" },
                ],
              },
              itemStyle: {
                color: context?.chartColor,
              },
            },
          ],
          xAxis: {
            type: "category",
            data: keys,
            axisLabel: {
              rotate: 45,
              textStyle: {
                color: context?.theme === "dark" ? "#fff" : "#000",
                fontSize: 10,
              },
              formatter: function (value, index) {
                return value.length > 11
                  ? value.substring(0, 11) + "..."
                  : value;
              },
            },
          },
        });
      } else {
        myChartOption("none");
      }
    } catch (error) {
      console.error("Genel Data Error", error);
      myChartOption("none");
    }
  }

  useEffect(() => {
    if (city && district) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city, district]);

  return chartOption ? (
    chartOption === "none" ? (
      <span className="d-block text-center">
        {context?.t?.no_data_available}
      </span>
    ) : (
      <ReactECharts
        option={chartOption}
        ref={chartRef}
        className="w-100 h-100"
      />
    )
  ) : (
    <div className="spinner-border text-theme"></div>
  );
}
